exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pl-0 {\n  padding-left: 0px !important;\n}\n.clear-filter {\n  float: right;\n  margin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/reports/inventory/warehouse.less
// module id = 3865
// module chunks = 0